/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Portada_Home from "./Componentes/Portada_Home";
import Proyectos_Home from "./Componentes/Proyectos_Home";
import Clientes_Home from "./Componentes/Clientes_Home";
import Servicio_Home from "./Componentes/Servicio_Home";
import Blog_Home from "./Componentes/Blog_Home";

import Destacado_Home from "./Componentes/Destacado_Home";
import Otros_Home from "./Componentes/Otros_Home";
import Home_Home from "./Componentes/Home_Home";

const Seccion_Home = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Home_Home/>
            </Grid>


            {/*<Grid container size={{xs: 12, sm: 12, md: 12}}>*/}
            {/*    <Portada_Home/>*/}
            {/*</Grid>*/}

            {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:16}}>*/}
            {/*    <Servicio_Home/>*/}
            {/*</Grid>*/}

            {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:16}}>*/}
            {/*    <Blog_Home/>*/}
            {/*</Grid>*/}


            {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:16}}>*/}
            {/*    <Clientes_Home/>*/}
            {/*</Grid>*/}

            {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:16}}>*/}
            {/*    <Destacado_Home/>*/}
            {/*</Grid>*/}

            {/*<Grid container*/}
            {/*      justifyContent={'center'}*/}
            {/*      alignItems={'flex-start'}*/}
            {/*      size={{xs: 12, sm: 12, md: 12}} sx={{ pt:16}}>*/}
            {/*    <Grid sx={{maxWidth:1400, px:3}}>*/}
            {/*        <Otros_Home/>*/}
            {/*    </Grid>*/}

            {/*</Grid>*/}


        </Grid>
    )

}
export default Seccion_Home;